import createOrDuplicateProject from '$src/api/endpoints/projects/createOrDuplicateProject'
import EditProjectModal from './EditProjectModal'
import ArchiveOrUnarchiveProjectModal from './ArchiveOrUnarchiveProjectModal'
import getProjects, {
  GetProjectsResult,
  GetProjectsQuery,
} from '$src/api/endpoints/projects/getProjects'
import {Component, React, observer} from '$src/handy'
import * as css from './ProjectsPage.css'
import PageLayout from '$src/common/PageLayout/PageLayout'
import {keyBy} from 'lodash'
import {getSnapshot} from 'mobx-state-tree'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import {DateTime} from 'luxon'
import GenericButton from '$src/common/GenericButton'
import CreateProjectModal, {makeFile} from './CreateProjectModal'
import {Link} from 'react-router-dom'

interface State {
  loading: boolean
  error: undefined | string
  loaded: boolean
  total: number
  listOfIds: Array<number>
  onlyQueryMyProjects: boolean
  mode:
    | {mode: 'CreateProjectModal'}
    | {mode: 'DuplicateProjectModal'; projectId: number}
    | {mode: 'ArchiveProjectModal'; projectId: number}
    | {mode: 'DeleteProjectModal'; projectId: number}
    | {mode: 'UnarchiveProjectModal'; projectId: number}
    | {mode: 'EditProjectModal'; projectId: number}
    | {mode: 'ProjectsList'}
}

const PER_PAGE = 50

@observer
export default class ProjectsPage extends Component<{history: any}, State> {
  tableInstance: ReactTable<$FixMe>
  constructor(props: {}, context: any) {
    super(props, context)
    const onlyMeLocalStorage = localStorage.getItem('onlyQueryMyProjects');
    this.state = {
      loading: false,
      error: undefined,
      loaded: false,
      mode: {mode: 'ProjectsList'},
      total: -1,
      listOfIds: [],
      onlyQueryMyProjects: onlyMeLocalStorage ? JSON.parse(onlyMeLocalStorage) === true : true,
    }
  }

  setTableInstance = (instance: ReactTable<$FixMe>) => {
    this.tableInstance = instance
  }

  UNSAFE_componentWillMount() {
    // if (this.state.loaded === false) this.loadProjects()
  }

  loadProjects = async (
    offset: number,
    limit: number,
    q: Partial<GetProjectsQuery>,
  ) => {
    this.setState(() => ({ loading: true, error: undefined, loaded: false }))
    let list: GetProjectsResult
    let total: number
    try {
      const query: GetProjectsQuery = {limit, offset, ...q}
      if (this.state.onlyQueryMyProjects) {
        query.userId = this.store.auth.getMyId()
      }
      const r = await this.callEndpoint(getProjects, query)
      list = r.projects
      total = r.total
      await new Promise(resolve => setTimeout(resolve, 1000))
    } catch (e) {
      this.setState(() => ({
        loading: false,
        loaded: false,
        error: e.message || 'Some unkown error happened on the server',
      }))
      return
    }

    const listOfIds = await list.map(s => s._id);

    list = await list.map(({ usersInvolved, ...rest }) => ({
      ...rest,
      usersInvolved: usersInvolved.map(({_id}) => _id),
    }))
    const byId = keyBy(list, '_id')
    this.store.projects.import(byId as any);
    this.setState(() => ({ loading: false, loaded: true, listOfIds, total }))
  }

  reload = () => {
    ;(this.tableInstance as $LibBugAny).fireFetchData()
  }

  renderModals() {
    const {state} = this
    return (
      <div>
        {(state.mode.mode === 'CreateProjectModal' ||
          state.mode.mode === 'DuplicateProjectModal') && (
          <CreateProjectModal
            key={
              state.mode.mode === 'CreateProjectModal'
                ? 'CreateProjectModal'
                : 'DuplicateProjectModal:' + state.mode.projectId
            }
            duplicateFrom={
              state.mode.mode === 'CreateProjectModal'
                ? undefined
                : state.mode.projectId
            }
            onRequestClose={() => {
              this.setState({mode: {mode: 'ProjectsList'}})
            }}
            onUpdateNeeded={this.reload}
          />
        )}
        {(state.mode.mode === 'ArchiveProjectModal' ||
          state.mode.mode === 'UnarchiveProjectModal') && (
          <ArchiveOrUnarchiveProjectModal
            key={JSON.stringify(state.mode)}
            projectId={state.mode.projectId}
            mode={state.mode.mode}
            onRequestClose={() => {
              this.setState({mode: {mode: 'ProjectsList'}})
            }}
            onUpdateNeeded={this.reload}
          />
        )}
        {state.mode.mode === 'EditProjectModal' && (
          <EditProjectModal
            key={JSON.stringify(state.mode)}
            projectId={state.mode.projectId}
            onRequestClose={() => {
              this.setState({mode: {mode: 'ProjectsList'}})
            }}
            onUpdateNeeded={this.reload}
          />
        )}
      </div>
    )
  }

  render() {
    const storedSorting = localStorage.getItem('projects-list-order');

    const listOfIds = this.state.listOfIds

    const list = listOfIds.map(id =>
      getSnapshot(this.store.projects.baseProjectsById.get(id)),
    )

    return (
      <PageLayout>
        {this.renderModals()}
        {this.state.error ? (
          <div className={css.error}>Error: {this.state.error}</div>
        ) : (
          <ReactTable
            ref={this.setTableInstance}
            loading={this.state.loading}
            manual
            pages={
              this.state.total === -1
                ? -1
                : Math.ceil(this.state.total / PER_PAGE)
            }
            showPageSizeOptions={false}
            defaultSorted={!!storedSorting ? [JSON.parse(storedSorting)] : [
              {
                id: 'creationDate',
                desc: true,
              },
            ]}
            className={css.table}
            pageSize={PER_PAGE}
            columns={this.columns()}
            data={this.state.loading ? [] : list || []}
            onFetchData={this._fetch}
            style={{
              height: '93vh',
            }}
          />
        )}
      </PageLayout>
    )
  }

  _fetch = (s: {
    page: number
    pageSize: number
    filtered: Array<{id: string; value: string}>
    sorted: Array<{id: string; desc: boolean}>
  }) => {
    const q: Partial<GetProjectsQuery> = {}
    const projectNameFilter = s.filtered.find(({id}) => id === 'projectName')
    if (projectNameFilter) {
      q.projectName = projectNameFilter.value
    }

    const customerNameFilter = s.filtered.find(({id}) => id === 'customerName')
    if (customerNameFilter) {
      q.customerName = customerNameFilter.value
    }

    const numberOfApartmentsFilter = s.filtered.find(
      ({id}) => id === 'numberOfApartments',
    )
    if (numberOfApartmentsFilter) {
      q.numberOfApartments = numberOfApartmentsFilter.value
    }

    const numberOfHousingCorporationsFilter = s.filtered.find(
      ({id}) => id === 'numberOfHousingCorporations',
    )
    if (numberOfHousingCorporationsFilter) {
      q.numberOfHousingCorporations = numberOfHousingCorporationsFilter.value
    }

    if (s.sorted.length > 0) {
      const sort = s.sorted[0]
      q.order = {
        column: sort.id as any,
        desc: sort.desc,
      }
      localStorage.setItem(
        'projects-list-order',
        JSON.stringify(sort),
      )
    }

    const limit = s.pageSize
    const offset = s.page * limit
    this.loadProjects(offset, limit, q)
  }

  toggleOnlyMyProjects = () => {
    localStorage.setItem(
      'onlyQueryMyProjects', (!this.state.onlyQueryMyProjects).toString()
    );
    this.setState({
      onlyQueryMyProjects: !this.state.onlyQueryMyProjects,
      loaded: false,
      loading: true,
      total: -1,
    })
    setTimeout(() => {
      this.tableInstance.fireFetchData()
    }, 10)
  }

  columns = () => {
    const myId: string | undefined = this.store.auth.getMyId()
    const onlyMe = this.state.onlyQueryMyProjects
    return [
      {
        Header: '',
        accessor: 'archived',
        sortable: false,
        width: 40,
        Cell: () => {
          return ''
        },
      },
      {
        Header: 'Name',
        accessor: 'name',
        id: 'projectName',
        sortable: false,
        filterable: true,
        Cell: ({original}: any) => {
          return original.archived ? (
            <div className={css.nameArchived}>{original.name}</div>
          ) : (
            <Link
              to={`/housing-corporations-list/${original._id}/${original.name}`}
            >
              {original.name}
            </Link>
          )
        },
      },
      {
        Header: 'Client',
        accessor: 'customer',
        id: 'customerName',
        sortable: false,
        filterable: true,
      },
      {
        Header: '# Housing Corporations',
        sortable: true,
        id: 'numberOfHousingCorporations',
        filterable: true,
        accessor: (row: any) => row.housingCorporations.length,
      },
      {
        sortable: true,
        Header: 'Created at',
        accessor: 'creationDate',
        filterable: false,
        sortMethod: (a: string, b: string) => {
          const aT = DateTime.fromISO(a)
          const bT = DateTime.fromISO(b)
          return aT > bT ? 1 : aT < bT ? -1 : 0
        },
        Cell: ({original}: {original: {creationDate: string}}) => {
          return DateTime.fromISO(original.creationDate).toLocaleString(
            DateTime.DATETIME_MED,
          )
        },
      },
      {
        sortable: true,
        Header: 'Evaluated at',
        accessor: 'evaluationDate',
        filterable: false,
        sortMethod: (a: string, b: string) => {
          const aT = DateTime.fromISO(a)
          const bT = DateTime.fromISO(b)
          return aT > bT ? 1 : aT < bT ? -1 : 0
        },
        Cell: ({original}: {original: {evaluationDate: string}}) => {
          return DateTime.fromISO(original.evaluationDate).toLocaleString(
            DateTime.DATETIME_MED,
          )
        },
      },
      {
        sortable: false,
        Header: () => {
          return (
            <label>
              Only mine:{' '}
              <input
                type="checkbox"
                checked={onlyMe}
                onChange={this.toggleOnlyMyProjects}
              />
            </label>
          )
        },
        id: 'involvesMe',
        accessor: () => 'TRUE',
        filterable: false,
        Cell: ({original}: {original: {usersInvolved: any}}) =>
          original.usersInvolved.indexOf(myId) > -1 ? 'Involves me' : 'Others',
      },
      {
        Header: () => {
          return (
              <GenericButton
                variant="round"
                onClick={() =>
                  this.setState(s => ({mode: {mode: 'CreateProjectModal'}}))
                }
                css={{container: css.createProjectButton}}
              >
                Create Project
              </GenericButton>
           
          )
        },
        sortable: false,
        resizable: false,
        width: 200,
        Cell: ({original}: {original: {_id: number; archived: string}}) => {
          return (
            <div className={css.operations}>
              <a
                href="#"
                className={css.operationButton}
                onClick={() =>
                  this.setState({
                    mode: {
                      mode: 'DuplicateProjectModal',
                      projectId: original._id,
                    },
                  })
                }
              >
                Duplicate
              </a>
              <span className={css.operationSeparator} />
              <a
                href="#"
                onClick={() =>
                  this.setState({
                    mode: {
                      mode: original.archived
                        ? 'UnarchiveProjectModal'
                        : 'ArchiveProjectModal',
                      projectId: original._id,
                    },
                  })
                }
                className={css.operationButton}
              >
                {original.archived ? 'Unarchive' : 'Archive'}
              </a>
              <span className={css.operationSeparator} />
              <a
                href="#"
                className={css.operationButton}
                onClick={() =>
                  this.setState({
                    mode: {mode: 'EditProjectModal', projectId: original._id},
                  })
                }
              >
                Edit
              </a>
            </div>
          )
        },
      },
    ]
  }
}



// WEBPACK FOOTER //
// ./src/projects/ProjectsPage.tsx